/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_DamperInputs */



/**
* | output |
* | --- |
* | "Damper" |
*
* @param {Air_Handler_Unit_DamperInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_damper = /** @type {((inputs?: Air_Handler_Unit_DamperInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_DamperInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Damper")
	return /** @type {LocalizedString} */ ("Volet")
});